import { baseApi } from '../../../../../app/services/baseApi';
import { DataExport, DataExportDownload } from './types';

interface PaginatedDataExports {
  count: number;
  next: string | null;
  previous: string | null;
  results: DataExport[];
}

export const dataExportApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // Newest first per the contract. Polling cadence is controlled by the consumer (DataArchive).
    getDataExports: build.query<DataExport[], void>({
      query: () => '/v1/charge/data-export',
      transformResponse: (response: PaginatedDataExports) => response.results,
      providesTags: ['DataExports'],
    }),
    requestDataExport: build.mutation<DataExport, void>({
      query: () => ({
        url: '/v1/charge/data-export',
        method: 'POST',
        // No options, no date range — the backend exports everything it holds about the user.
        body: {},
      }),
      invalidatesTags: ['DataExports'],
    }),
    // Resolves the short-lived signed download URL. Kept as a mutation (not a cached query) because
    // each call is a one-shot, re-auth-gated side effect; the consumer hands `download_url` straight
    // to the OS and never re-reads it. Error branches (401 reauth_required / 404 / 410) are handled
    // by `useDownloadDataExport`.
    getDataExportDownloadUrl: build.mutation<DataExportDownload, string>({
      query: (referenceId) => ({
        url: `/v1/charge/data-export/${referenceId}/download`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetDataExportsQuery, useRequestDataExportMutation, useGetDataExportDownloadUrlMutation } =
  dataExportApi;
